<template>
  <div>
    <div id="goback" style="margin-bottom: 10px; font-size: 14px">
      <i class="el-icon-back" @click="$router.go(-1)" style="cursor: pointer"
        >返回</i
      >&nbsp;&nbsp;
      <span style="font-size: 14px; color: rgb(192, 196, 204)">|</span>
      &nbsp;&nbsp;<span style="color: rgb(192, 196, 204)">编号：</span
      >{{ pcode }} <span style="color: rgb(192, 196, 204)">项目：</span
      >{{ pname }}
    </div>
    <div id="content">
      <div class="op">
        <el-button
          size="small"
          type="primary"
          icon="el-icon-zoom-in"
          @click="operate('新建', null, null)"
          :disabled="doing"
          >创建reportal</el-button
        >
        <el-button
          size="small"
          icon="el-icon-view"
          @click="topage('kpipv')"
          :disabled="doing"
          >PV 浏览</el-button
        >
      </div>
      <div class="plist">
        <el-table :data="tableData" style="width: 1200px">
          <el-table-column prop="id" label="id" v-if="false"> </el-table-column>
          <el-table-column prop="name" label="报告名称" width="400">
            <template slot-scope="scope">
              {{ scope.row.name}}<span v-if="scope.row.moren" class="moren">默认</span><span v-if="scope.row.open" class="open">开放浏览</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="600">
            <template slot-scope="scope">
              <router-link
                :to="{
                  name: 'kpi',
                  params: {
                    pid: pid,
                    kid: scope.row.id,
                    bname: scope.row.name,
                    pname: pname,
                    pcode: pcode,
                  },
                }"
                class="caozuo"
                >查看</router-link
              >
              <router-link
                :to="{
                  name: 'quotatab',
                  params: {
                    pid: pid,
                    kid: scope.row.id,
                    bname: scope.row.name,
                    pname: pname,
                    pcode: pcode,
                  },
                }"
                class="caozuo"
                >配额表</router-link
              >
         
              <router-link
                :to="{
                  name: 'quotarun',
                  params: {
                    pid: pid,
                    kid: scope.row.id,
                    bname: scope.row.name,
                    pname: pname,
                    pcode: pcode,
                  },
                }"
                class="caozuo"
                >撞数</router-link
              >
              <el-button
                round
                size="mini"
                @click="operate('复制', scope.row.name, scope.row.id)"
                class="result"
                :disabled="doing"
                >复制</el-button
              >
              <el-button
                round
                size="mini"
                @click="operate('重命名', scope.row.name, scope.row.id)"
                class="result"
                :disabled="doing"
                >重命名</el-button
              >
 <el-button
                round
                size="mini"
                @click="operateChartImport(scope.row.name, scope.row.id)"
                class="result"
                :disabled="doing"
                >表头表侧</el-button
              >
              <el-button
                :disabled="doing"
                type="danger"
                round
                size="mini"
                @click="del(scope.row.id)"
                class="result"
                plain
                >删除</el-button
              >
             
            </template>
          </el-table-column>
          <el-table-column prop="created_time" label="创建日期">
            <template slot-scope="scope">
              <div :style="{ color: '#c0c4cc', 'font-size': '12px' }">
                {{ scope.row.created_time }}
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="fenye">
        <el-pagination
          @current-change="getreport"
          :current-page.sync="currentPage"
          :page-size="10"
          layout="total, prev, pager, next"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <!-- 表头表侧上传弹窗 -->
    <el-dialog title="表头表侧" :visible.sync="chartImportDialogVisible" width="500px" :before-close="handleChartImportClose">
      <div class="upload-container">
        <el-upload
          class="upload-demo"
          :action="uploadAction"
          :on-success="handleUploadSuccess"
          :on-error="handleUploadError"
          :headers="uploadHeaders"
          :data="{ pid: pid, kid: currentKid }"
          :auto-upload="false"
          :show-file-list="showFileList"
          accept=".xlsx,.xls"
          :before-upload="beforeAvatarUpload"
          ref="uploadRef"
          :limit="1"
        >
          <div class="upload-area">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            <div class="el-upload__tip" slot="tip">只能上传xlsx/xls文件</div>
            <div class="el-upload__tip" slot="tip">导入的excel中要包含"表头"和"表侧"两个表，每个表中的数据格式保持跟datamap一致</div>
          </div>
        </el-upload>
        <div class="button-group" style="margin-top: 20px;">
          <el-button type="primary" @click="submitUpload" icon="el-icon-upload2" :loading="uploadLoading">导入生成</el-button>
          <el-button @click="clearHeader" icon="el-icon-delete" :loading="clearLoading.header">清除表头</el-button>
          <el-button @click="clearSide" icon="el-icon-delete" :loading="clearLoading.side">清除表侧</el-button>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleChartImportClose">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "ReportList",
  props: ["pid", "pname", "pcode"],
  data() {
    return {
      doing: false,
      tableData: [],
      currentPage: 1,
      total: 1,
      chartImportDialogVisible: false,
      currentKid: null,
      uploadAction: '',
      uploadHeaders: {},
      showFileList: true,
      token: '',
      uploadLoading: false,
      clearLoading: { header: false, side: false },
    };
  },

  created() {
    this.getreport(this.currentPage);
  },
  methods: {
    topage(t) {
      this.$router.push({
        name: t,
        params: { pid: this.pid, pname: this.pname, pcode: this.pcode },
      });
    },

    operate(op, name, kid) {
      let cpid = kid;
      let newname = name;
      switch (op) {
        case "新建":
          cpid = null;
          newname = null;
          break;
        case "复制":
          newname = name + "-副本";
          break;
      }
      this.$prompt("请输入reportal名称", op, {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /\S+/,
        inputErrorMessage: "请输入非空字符",
        inputValue: newname,
      })
        .then(({ value }) => {
          if (op == "重命名") {
            this.rename(cpid, value);
          } else {
            this.add(cpid, value);
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消输入",
          });
        });
    },
    add(cpid, name) {
      this.doing = true;
      var api = this.COMMON.httpUrl + "reportAdd";
      var data = {
        cpid: cpid,
        name: name,
        pid: this.pid,
        pname: this.pname,
      };
      this.axios.post(api, data).then((response) => {
        this.doing = false;
        var rs = response.data;
        if (rs.code) {
          this.$message.error(rs.message);
        } else {
          this.tableData = rs.data.data;
          this.currentPage = rs.data.current_page;
          this.total = rs.data.total;
        }
      });
    },
    rename(kid, name) {
      this.doing = true;
      var api = this.COMMON.httpUrl + "reportRename";
      var data = {
        kid: kid,
        name: name,
        pid: this.pid,
        pname: this.pname,
      };
      this.axios.post(api, data).then((response) => {
        this.doing = false;
        var rs = response.data;
        if (rs.code) {
          this.$message.error(rs.message);
        } else {
          this.tableData = rs.data.data;
          this.currentPage = rs.data.current_page;
          this.total = rs.data.total;
        }
      });
    },
    del(kid) {
      this.$confirm("删除后相关数据将被清除,是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.rundel(kid);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    rundel(kid) {
      this.doing = true;
      var api = this.COMMON.httpUrl + "reportDel";
      var data = {
        pid: this.pid,
        kid: kid,
      };
      this.axios.post(api, data).then((response) => {
        var rs = response.data;
        this.doing = false;
        if (rs.code) {
          this.$message.error(rs.message);
        } else {
          this.$message.success("删除成功");
          this.tableData = rs.data.data;
          this.currentPage = rs.data.current_page;
          this.total = rs.data.total;
        }
      });
    },
    getreport(page) {
      var api = this.COMMON.httpUrl + "reportList";
      var data = {
        pid: this.pid,
        page: page,
      };
      this.axios.post(api, data).then((response) => {
        var rs = response.data;
        if (rs.code) {
          this.$message.error(rs.message);
        } else {
          this.tableData = rs.data.data;
          this.currentPage = rs.data.current_page;
          this.total = rs.data.total;
        }
      });
    },
    
    // 表头表侧相关方法
    operateChartImport(name, kid) {
      this.currentKid = kid;
      this.uploadAction = this.COMMON.httpUrl + 'kpiChartDataImport';
      this.token = 'Bearer ' + localStorage.getItem('token');
      this.uploadHeaders = {
        'Authorization': this.token        
      };
      this.chartImportDialogVisible = true;
    },
    
    handleChartImportClose() {
      this.chartImportDialogVisible = false;
      this.currentKid = null;
    },
    
    beforeAvatarUpload(file) {
      let fileName = file.name.substring(file.name.lastIndexOf(".") + 1);
      const isXls = fileName === "xls";
      const isXlsx = fileName === "xlsx";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!(isXls || isXlsx)) {
        this.$message({
          message: "上传文件只能是 xls、xlsx格式!",
          type: "warning",
        });
        return false;
      }
      
      if (!isLt2M) {
        this.$message({
          message: "文件大小不能超过2MB!",
          type: "warning",
        });
        return false;
      }
    },
    
    submitUpload() {
      // 检查参数是否正确设置
      if (!this.pid || !this.currentKid) {
        this.$message.error('项目ID或报表ID不能为空');
        return;
      }
      
      // 检查是否选择了文件
      const uploadFiles = this.$refs.uploadRef.uploadFiles;
      if (!uploadFiles || uploadFiles.length === 0) {
        this.$message.warning('请先选择要上传的文件');
        return;
      }
      
      this.uploadLoading = true;
      this.$refs.uploadRef.submit();
    },
    
    clearHeader() {
      this.clearDimension(1, '表头');
    },
    
    clearSide() {
      this.clearDimension(2, '表侧');
    },
    
    clearDimension(weidu, typeName) {
      // 确认操作
      this.$confirm(`确定要清除${typeName}吗？此操作不可撤销。`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 设置对应按钮的loading状态
        if (weidu === 1) {
          this.clearLoading.header = true;
        } else if (weidu === 2) {
          this.clearLoading.side = true;
        }
        // 发送请求到后端
        const api = this.COMMON.httpUrl + 'kpiChartDelete';
        const data = {
          pid: this.pid,
          kid: this.currentKid,
          weidu: weidu
        };
        
        this.axios.post(api, data).then((response) => {
          const rs = response.data;
          if (rs.code) {
            this.$message.error(rs.message || `清除${typeName}失败`);
          } else {
            this.$message.success(`${typeName}清除成功，删除了 ${rs.data.deleted_count} 条记录`);
          }
        }).catch((error) => {
          this.$message.error(`清除${typeName}请求失败`);
          console.error('Clear dimension error:', error);
        }).finally(() => {
          // 确保无论成功或失败都停止对应的loading
          if (weidu === 1) {
            this.clearLoading.header = false;
          } else if (weidu === 2) {
            this.clearLoading.side = false;
          }
        });
      }).catch(() => {
        // 用户取消操作
        this.$message.info(`已取消清除${typeName}`);
      });
    },
    
    handleUploadSuccess(response) {
      // 停止loading
      this.uploadLoading = false;
      // 检查后端返回的数据格式
      if (response && typeof response === 'object' && 'code' in response) {
        if (response.code > 0) {
          // code大于0表示有错误，显示错误信息
          this.$message.error(response.message || '上传失败');
        } else {
          // code等于0或小于0表示成功
          this.$message.success('上传成功');
          // 成功后清除上传列表
          this.$refs.uploadRef.clearFiles();
        }
      } else {
        // 如果响应格式不符合预期，则认为上传成功
        this.$message.success('上传成功');
        // 成功后清除上传列表
        this.$refs.uploadRef.clearFiles();
      }
    },
    
    handleUploadError(err) {
      this.uploadLoading = false;
      this.$message.error('上传失败');
      console.error('Upload error:', err);
    }
  },
};
</script>
  
<style scoped>
#content {
  background-color: white;
  width: 1200px;
  text-align: left;
  padding-left: 0px;
}

.op {
  padding: 20px 0;
}

.fenye {
  margin-top: 20px;
}
.open {
  margin-left: 15px;
  border-radius: 8px;
  padding: 4px 8px;
  font-size: 12px;
  color: white;
  background-color: rgb(82 200 43);
}

span.moren {
  margin-left: 15px;
  border-radius: 8px;
  padding: 4px 8px;
  font-size: 12px;
  color: white;
  background-color:#F56C6C;
}
.caozuo {
  color: #409eff !important;
  margin-right: 15px;
}

/* 表头表侧弹窗样式 */
.upload-container {
  text-align: center;
}

.upload-area .el-upload__tip:last-child {
  margin-top: 10px;
  padding: 8px;
  background-color: #f4f4f5;
  border-radius: 4px;
  color: #606266;
}

.upload-area {
  border: 2px dashed #d9d9d9;
  border-radius: 6px;
  padding: 40px;
  text-align: center;
  cursor: pointer;
  transition: border-color 0.3s;
}

.upload-area:hover {
  border-color: #409eff;
}

.upload-demo {
  display: inline-block;
  width: 100%;
}

.button-group {
  display: flex;
  justify-content: center;
  gap: 10px;
  flex-wrap: wrap;
}
</style>